import React, { createContext, useContext, useEffect, useState } from "react";
import { useUsers } from "./UsersContext";

const SelectedCompanyContext = createContext(null);

export const SelectedCompanyProvider = ({ children }) => {
  const { user } = useUsers();
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  // ⭐ OLETUSCOMPANY – YKSI PAIKKA
  useEffect(() => {
    if (!selectedCompanyId && user?.companies?.length) {
      setSelectedCompanyId(user.companies[0]);
    }
  }, [user?.companies, selectedCompanyId]);

  return (
    <SelectedCompanyContext.Provider
      value={{ selectedCompanyId, setSelectedCompanyId }}
    >
      {children}
    </SelectedCompanyContext.Provider>
  );
};

export const useSelectedCompany = () => {
  const ctx = useContext(SelectedCompanyContext);
  if (!ctx) {
    throw new Error(
      "useSelectedCompany must be used inside SelectedCompanyProvider"
    );
  }
  return ctx;
};
